import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
// Owner directive: content must be visible the instant it scrolls in.
// Animations trigger 140px BEFORE the element enters the viewport and
// complete fast — no blank-then-pop.
const EARLY = "140px";

export const Reveal = ({ children, delay = 0, y = 14, className = "", once = true }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: EARLY }}
      transition={{ duration: 0.38, delay: Math.min(delay, 0.08), ease: EASE }}
    >
      {children}
    </motion.div>
  );
};

export const Stagger = ({ children, className = "", gap = 0.05 }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: EARLY }}
      variants={{ hidden: {}, show: { transition: { staggerChildren: gap } } }}
    >
      {children}
    </motion.div>
  );
};

export const StaggerItem = ({ children, className = "" }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      variants={{
        hidden: { opacity: 0, y: 14 },
        show: { opacity: 1, y: 0, transition: { duration: 0.36, ease: EASE } },
      }}
    >
      {children}
    </motion.div>
  );
};

export const MaskLines = ({ lines, className = "", lineClassName = "", delay = 0.05 }) => {
  const reduce = useReducedMotion();
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span
            className={`block will-change-transform ${lineClassName}`}
            initial={reduce ? false : { y: "112%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.6, delay: delay + i * 0.08, ease: EASE }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};
